export enum View {
  CardGrid = "grid",
  Table = "table",
}
